class LWHeader extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
    }

    // We kijken of het 'fixed' attribuut verandert
    static get observedAttributes() {
        return ['fixed'];
    }

    render() {
        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                display: block;
                background: #333;
                color: white;
                padding: 1rem 0;
                margin-bottom: 20px;
                width: 100%;
                z-index: 1000;
                transition: all 0.3s ease;
            }

            /* Wanneer het 'fixed' attribuut aanwezig is op de tag */
            :host([fixed]) {
                position: sticky;
                top: 0;
                left: 0;
                box-shadow: 0 2px 10px rgba(0,0,0,0.2);
            }

            .header-content {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            ::slotted(a) {
                color: white;
                text-decoration: none;
                margin-left: 20px;
                font-size: 0.95rem;
                transition: opacity 0.2s;
            }

            ::slotted(a:hover) {
                opacity: 0.7;
            }

            .logo {
                font-size: 1.2rem;
            }
        </style>
        <lw-container>
            <div class="header-content">
                <div class="logo">
                    <slot name="logo"><strong>LW</strong> System</slot>
                </div>
                <nav>
                    <slot></slot> 
                </nav>
            </div>
        </lw-container>
        `;
    }
}
if (!customElements.get('lw-header')) {
    customElements.define('lw-header', LWHeader);
}